import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import LiveEvents from './components/LiveEvents';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '开云体育',
    url: 'https://www.kaiyunsports.com',
    description: '开云体育是领先的综合体育平台，提供丰富的体育赛事资讯、赛事直播、体育竞技数据及专业服务。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: 'customer service',
      email: 'contact@kaiyunsports.com',
      availableLanguage: 'Chinese',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '开云体育',
    url: 'https://www.kaiyunsports.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.kaiyunsports.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '开云体育 - 官方正品体育平台',
    description: '开云体育是领先的综合体育平台，提供丰富的体育赛事资讯、赛事直播、体育竞技数据及专业服务。',
    url: 'https://www.kaiyunsports.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '开云体育',
      url: 'https://www.kaiyunsports.com',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '开云体育平台提供哪些体育赛事内容？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '开云体育平台涵盖足球、篮球、网球、电竞、乒乓球、羽毛球、F1赛车等全球主流体育项目，提供赛事资讯、赛程数据、实时比分和专业的赛事分析解读。',
        },
      },
      {
        '@type': 'Question',
        name: '如何获取最新的体育赛事资讯？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过访问开云体育官网首页和分类页面，随时获取全球最新的体育赛事资讯。编辑团队全天候更新内容，确保您不错过任何重要体育新闻。',
        },
      },
      {
        '@type': 'Question',
        name: '开云体育的赛事直播功能如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '开云体育提供丰富的赛事直播资源，涵盖足球、篮球、电竞等多个热门体育项目的实时直播，提供实时比分和赛况更新。',
        },
      },
      {
        '@type': 'Question',
        name: '开云体育平台是否免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '开云体育平台向所有用户免费开放核心的体育资讯和赛事数据服务。用户可以自由浏览体育新闻、赛事分析和比分数据。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系开云体育客服？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过"关于我们"页面获取详细联系方式，包括客服邮箱contact@kaiyunsports.com和客服电话400-888-6666。',
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title="开云体育 - 官方正品体育平台 | 赛事资讯、直播、数据一站式服务"
        description="开云体育是领先的综合体育平台，提供丰富的体育赛事资讯、赛事直播、体育竞技数据及专业服务。开云体育汇聚全球顶级体育内容，助您畅享极致体育体验，立即加入开云体育，探索精彩无限的体育世界。"
        keywords="开云体育,开云体育官网,开云体育平台,开云体育登录,开云体育注册,开云体育赛事,开云体育直播,体育资讯,赛事直播,体育数据"
        canonicalPath="/"
        schema={homeSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryCards />
        <LiveEvents />
        <ArticleList />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}